@if (svg$ | async; as svg) {
    <ng-container class="map-category-icon">
        @if (svg.data) {
            <div
                class="map-category-icon__inner"
                [attr.aria-label]="altText"
                [innerHTML]="svg.data"
            ></div>
        } @else {
            @switch (svg.error.key) {
                @case (loadingStatus) {
                    <ng-container
                        [ngTemplateOutlet]="LoadingTemplate"
                    />
                }
                @default {
                    <i
                        tabindex=0
                        class="pi pi-sync cursor-pointer color-error"
                        [pTooltip]="'Das Icon konnte nicht geladen werden. Klicken Sie hier, um es erneut zu versuchen.'"
                        (click)="reloadIcon($event)"
                        (keydown.enter)="reloadIcon($event)"
                        (keydown.space)="reloadIcon($event)"
                    ></i>
                }
            }
        }
    </ng-container>
} @else {
    <i class="pi pi-spin pi-spinner loading-icon"></i>
}

<ng-template #LoadingTemplate>
    <i class="pi pi-spin pi-spinner loading-icon"></i>
</ng-template>
